import { z } from 'zod'

/**
 * The one password policy, mirrored from the API
 * (portal-be src/common/validators/password-policy.ts). Use
 * `newPasswordSchema` for every field where someone chooses a password.
 *
 * The 72-byte ceiling is bcrypt's input limit: anything longer would be
 * silently ignored, so it is refused instead. Existing passwords are never
 * re-checked; the rule applies when a password is set or changed.
 */
export const PASSWORD_POLICY = {
  minLength: 8,
  maxBytes: 72,
} as const

export const PASSWORD_HINT = `Use ${PASSWORD_POLICY.minLength} to ${PASSWORD_POLICY.maxBytes} characters.`

const encoder = new TextEncoder()

export const newPasswordSchema = z
  .string()
  .min(
    PASSWORD_POLICY.minLength,
    `Password must be at least ${PASSWORD_POLICY.minLength} characters.`
  )
  .refine((value) => encoder.encode(value).length <= PASSWORD_POLICY.maxBytes, {
    message: `Password is too long: use at most ${PASSWORD_POLICY.maxBytes} characters (accented letters and emoji count as 2 to 4).`,
  })
  .refine((value) => value.trim().length > 0, {
    message: 'Password cannot be only spaces.',
  })
